import { render } from "./g-text-field.vue?vue&type=template&id=4f95aa08&ts=true"
import script from "./g-text-field.vue?vue&type=script&lang=tsx"
export * from "./g-text-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__